import { Link as Link$1 } from '@mui/material';
import { jsx } from 'react/jsx-runtime';

const Link = _ref => {
  let {
    variant,
    sx,
    ...otherProps
  } = _ref;
  return /*#__PURE__*/jsx(Link$1, {
    ...otherProps,
    sx: {
      ...sx,
      transition: theme => theme.transitions.create(['color'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.standard
      }),
      color: theme => otherProps.color === 'inherit' ? undefined : theme.palette.mode === 'dark' || variant === 'dark' ? theme.palette.darkMode60 : theme.palette.blueBase,
      ':hover': {
        color: theme => theme.palette.darkMode40
      }
    }
  });
};

export { Link };
